import { render, staticRenderFns } from "./FaultKanban.vue?vue&type=template&id=996084d8&scoped=true"
import script from "./FaultKanban.vue?vue&type=script&lang=ts"
export * from "./FaultKanban.vue?vue&type=script&lang=ts"
import style0 from "./FaultKanban.vue?vue&type=style&index=0&id=996084d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996084d8",
  null
  
)

export default component.exports